export default "__VITE_ASSET__CBj9Ftao__"